module.exports = __webpack_public_path__ + "static/media/galerija_2022_0026.e6631f9c.jpg";